<template> 
 <div>

  <b-container v-show="(!isBusy && !errored)" fluid> 
    <b-row>
        <b-col md="5" class="my-1 col-centered">
    
    <b-form-group class="mb-0 mt-2">
        <b-input-group>
        <b-form-input v-model="contains" autofocus v-on:keyup.enter="onEnter" placeholder="Find in items..."></b-form-input>
        <b-input-group-append>
            <b-button class="ml-1" variant="outline-dark" :disabled="!contains" @click="fetchData" >&#x1F50D; Search </b-button>
            <b-button class="ml-1" variant="outline-dark"  @click="clear"> &#10008; Clear</b-button>
        </b-input-group-append>
        </b-input-group>
    </b-form-group>

    </b-col>
    </b-row>
  </b-container> 

    <div id="poitems">
    <b-table
        responsive
        small
        striped
        outlined
        head-variant="light"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="isBusy"
        :items="data"
        :fields="tableFields"
    >
        <template v-slot:cell(po)="data">
            <div> <b-link :to="{ name: 'PurchaseOrder', params: { id: projectId, poId: data.value  }  }" > {{data.value}}  </b-link> </div>
        </template>

        <template v-slot:cell(item)="data">
            <div> {{parseInt(data.value)}} </div>
        </template>

        <template v-slot:cell(outstanding)="data">
            <div v-if="!data.item.outstanding == 0"> {{data.item.outstanding}} </div>
        </template>
        
        <template v-slot:cell(received)="data">
            <div v-if="!data.item.received == 0"> {{data.item.received}} </div>
        </template>

        <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner></b-spinner>
        <div>
            <strong>Loading...</strong>
        </div>
        </div>
   
    </b-table>
    </div>

    <div v-if="totalRows==0&&searched"> (No results found) </div>

    <b-pagination
      v-show="totalRows>perPage"
      v-model="currentPage"
      align="center"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="poitems"
      hide-ellipsis
    ></b-pagination>


 </div>
</template>

<script>
export default {
  name: "PoItemSearch",
  props: {},
  components: {},
  
  data: function() {
    return {
      projectId: this.$route.params.id, 
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      contains: null,
      selectedItem: [],
      searched: false,
      isBusy: false,
      data: [],
      errored: false, 
      error: "",
            tableFields: [
        {
          key: "po",
          sortable: true,
          label: "PO"
        }, 
        {           
          key: "item",
          sortable: true,
          label: "Item"
        },
        {
          key: "description",
          sortable: true,
          label: "Description"
        },
        {
          key: "quantity",
          sortable: true,
          label: "Qty",
          class: "text-right"
        },
        {
          key: "unit",
          sortable: false,
          label: " "
        },
        {
          key: "received",
          sortable: true,
          label: "Rec'd",
          class: "text-right"
        },
        {
          key: "outstanding",
          sortable: true,
          label: "O/s",
          class: "text-right"
        }
      ]
    }
  },
 
 methods: {
     fetchData() {
      this.isBusy = true;   
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/PurchaseOrderItems/Search/"+this.projectId+"/"+this.contains, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.data = response.data;
            this.totalRows = this.data.length;
            this.searched = true;
          })
          .catch(error => {
            this.dataError = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },

    onEnter(){
        if(this.contains){
            this.fetchData();
        }
    },
    
    clear(){
        this.contains = "";
        this.data = [];
        this.totalRows = 0;
        this.searched = false;
    },

 },

activated(){
 
}
  
}
</script>

<style scoped>



#poitems {
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  padding-top: 10px;
  
}

@media (max-width: 400px) {
    #poitems {
    font-size:.75rem;
    }
}


.col-centered {
  float: none;
  margin: 0 auto;
}

.pagination > li > a,
.pagination > li > span {
  color: darkred;
}


</style>